/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";

import Modal, { ModalHeader, ModalTab } from "../Modal";
import TaskIssueList from "./TaskIssueList";
import { TASK_TYPE_GROUPS } from "../../constants/TASK";
import Task from ".";

// Redux Store
import { useSelector } from "react-redux";
import { setTask } from "../../utils/task";

const taskIssueList = TASK_TYPE_GROUPS;

const TaskRequest = () => {
  const modalEl = useRef(null);
  const [activeTab, setActiveTab] = useState("all");
  const [minHeight, setMinHeight] = useState(0);
  const tabList = [
    {
      label: "전체",
      action: setActiveTab,
      value: "all",
    },
    ...taskIssueList.map(({ type }) => ({
      label: type,
      action: setActiveTab,
      value: type,
    })),
  ];
  const { isOpen, type, targetIdx, approvalTargetIdx, taskIdx, mode } = useSelector((store) => store.Task);

  const reset = () => {
    setTask();
    setActiveTab("all");
    setMinHeight(0);
  };
  const close = (e) => {
    if (e) {
      e.preventDefault();
    }
    setTask({ isOpen: false });
    setTimeout(() => {
      reset();
    }, 500);
  };

  useEffect(() => {
    if (isOpen && modalEl && modalEl.current) {
      setTimeout(() => {
        setMinHeight(modalEl.current.offsetHeight);
      }, 500);
    }
  }, [isOpen, modalEl]);

  return (
    <>
      <Modal
        isOpen={isOpen}
        type={type ? "fit" : "default"}
        className='print-out'
        close={close}
      >
        {type ? (
          <Task
            type={type}
            close={close}
            approvalTargetIdx={approvalTargetIdx}
            targetIdx={targetIdx}
            taskIdx={taskIdx}
            mode={mode}
          />
        ) : (
          <div
            ref={modalEl}
            style={{
              minHeight,
            }}
          >
            <ModalHeader>할일 요청</ModalHeader>
            <ModalTab tabList={tabList} active={activeTab} />
            <TaskIssueList activeType={activeTab} />
          </div>
        )}
      </Modal>
    </>
  );
};

export default TaskRequest;
